import { MAX_UPLOAD_BYTES } from '@mailpilot/shared';
import { api, ApiError } from './api';
import { bytes } from './format';

/** POST /api/uploads (multipart). Validates size client-side first. */
export async function uploadFile(file: File) {
  if (file.size > MAX_UPLOAD_BYTES) throw new ApiError(413, 'too_large', `${file.name} is ${bytes(file.size)} — the limit is ${bytes(MAX_UPLOAD_BYTES)}.`);
  const fd = new FormData();
  fd.append('file', file, file.name);
  return api('POST /api/uploads', { body: fd });
}

export function readFileText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result ?? ''));
    r.onerror = () => reject(r.error);
    r.readAsText(file);
  });
}
